import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from '@env/environment';

import { Setting } from '@models/setting';
import { Locale } from '@app/types/locale';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';





export const itemTwo: any = {
  "systemParameters":[
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-06-09T08:39:59.544+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-06-09T08:39:59.544+00:00",
          "version":0,
          "systemParameterId":"d0c2a756-7bcd-45f2-846b-7c62958e1702",
          "code":"SYS_SENDER_EMAIL_ADDRESS",
          "description":"System Email Sender Address",
          "value":"742403352@qq.com",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-06-09T08:39:59.944+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-06-09T08:39:59.944+00:00",
          "version":0,
          "systemParameterId":"5db110aa-a144-47d1-8389-5d0256f42e30",
          "code":"SYS_SENDER_EMAIL_NAME",
          "description":"System Email Sender Name",
          "value":"The Solung System",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-06-14T06:38:12.307+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-06-14T06:38:12.307+00:00",
          "version":0,
          "systemParameterId":"9f682bba-e3fe-4432-ad6f-4fe525c4ebd3",
          "code":"DATE_OF_ANNUAL_RETURN_PUBLIC_COMPANY",
          "description":"Date Of Annual Return Public Company",
          "value":"183",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-06-14T06:38:12.517+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-06-14T06:38:12.517+00:00",
          "version":0,
          "systemParameterId":"51bd8628-c36f-46ee-a3ab-96733fc83254",
          "code":"DATE_OF_ANNUAL_RETURN_GUANRANTEE_COMPANY",
          "description":"Date Of Annual Return Guanrantee Company",
          "value":"274",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-06-09T07:09:39.104+00:00",
          "updatedUserId":"60fdf891-e47c-4315-860d-eb1ba962b37a",
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-09-19T08:26:03.591+00:00",
          "version":3,
          "systemParameterId":"3048fc90-f68e-4334-987a-13f83fef67cf",
          "code":"DEADLINE_OF_ANNUAL_RETURN_HK",
          "description":"Deadline Of Annual Return HK Date",
          "value":"30",
          "type":null
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-09-30T03:21:00.274+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-09-30T03:21:00.274+00:00",
          "version":0,
          "systemParameterId":"60825eea-69df-47bd-b2c5-0f99d0f487fe",
          "code":"USR_MAX_LOGIN_FAIL_COUNT",
          "description":"Maximum Login Fail Count",
          "value":"5",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-09-30T03:21:00.125+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-09-30T03:21:00.125+00:00",
          "version":0,
          "systemParameterId":"7fcb4cf6-fa7d-4110-92d3-2676db47b89b",
          "code":"USR_SESSION_TIMEOUT",
          "description":"Login Session Timeout (minutes)",
          "value":"30",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-18T12:37:56.848+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-18T12:37:56.848+00:00",
          "version":0,
          "systemParameterId":"34e92dc5-97b2-494a-8252-90afd2c4dcf4",
          "code":"INDIVIDUAL_PASSPORT_VALID_THROUGH",
          "description":"Individual Passport Valid Through",
          "value":"60",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-18T12:37:57.038+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-18T12:37:57.038+00:00",
          "version":0,
          "systemParameterId":"8907a091-013c-4b35-bec8-d6a4620ae2b8",
          "code":"COMPANY_DEADLINE_FOR_RENEWAL_OF_BR",
          "description":"Company Deadline For Renewal Of BR",
          "value":"30",
          "type":"setting"
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-18T12:37:57.048+00:00",
          "updatedUserId":null,
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-18T12:37:57.048+00:00",
          "version":0,
          "systemParameterId":"6ce876db-0df7-4e5f-b185-6052aaec7f62",
          "code":"COMPANY_BILLING_FROM_DATE",
          "description":"Company Billing From Date",
          "value":"30",
          "type":"setting"
      }
  ],
  "letterInfos":[
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-19T09:41:47.585+00:00",
          "updatedUserId":"60fdf891-e47c-4315-860d-eb1ba962b37a",
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-19T13:55:48.586+00:00",
          "version":10,
          "letterInfoId":"840abd71-5b50-450a-a135-c591c57fad0b",
          "itemType":"SOLUNG",
          "fileType":"INVOICING",
          "letterImage":null
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-19T09:41:47.713+00:00",
          "updatedUserId":"60fdf891-e47c-4315-860d-eb1ba962b37a",
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-19T13:55:48.606+00:00",
          "version":10,
          "letterInfoId":"72ba0894-79dd-4f1c-96c9-745baa9a5b23",
          "itemType":"FAM_D",
          "fileType":"INVOICING",
          "letterImage":{
              "binaryFileId":"59807773-e775-4c12-bd4e-99682fd909b2",
              "content":"",
              "fileName":"b2b_email_banner_image.png",
              "fileSize":61043
          }
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-19T09:41:47.724+00:00",
          "updatedUserId":"60fdf891-e47c-4315-860d-eb1ba962b37a",
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-19T13:55:48.674+00:00",
          "version":10,
          "letterInfoId":"74e30ed2-b34c-4980-8100-40aaf75628fb",
          "itemType":"FAM_S",
          "fileType":"INVOICING",
          "letterImage":{
              "binaryFileId":"6d471e5d-8efb-4e8c-8f92-505fa35f2fcc",
              "content":"",
              "fileName":"B2B_Bg.jpg",
              "fileSize":683242
          }
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-19T09:41:47.734+00:00",
          "updatedUserId":"60fdf891-e47c-4315-860d-eb1ba962b37a",
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-19T13:55:48.741+00:00",
          "version":10,
          "letterInfoId":"6aa0b6f0-5ec9-4d2d-b2a3-f97596e4b53c",
          "itemType":"FAM_D",
          "fileType":"RECEIPT",
          "letterImage":{
              "binaryFileId":"dc3c04ec-276d-4722-a668-d1f6d0b696d2",
              "content":"",
              "fileName":"517.png",
              "fileSize":101079
          }
      },
      {
          "createdUserId":null,
          "createdUserUsername":null,
          "createdUserFullname":null,
          "createdUserEmail":null,
          "createdDate":"2022-10-19T09:41:47.742+00:00",
          "updatedUserId":"60fdf891-e47c-4315-860d-eb1ba962b37a",
          "updatedUserUsername":null,
          "updatedUserFullname":null,
          "updatedUserEmail":null,
          "updatedDate":"2022-10-19T13:55:48.761+00:00",
          "version":10,
          "letterInfoId":"2e20bb71-828f-4819-acca-ae863649cf6c",
          "itemType":"FAM_S",
          "fileType":"RECEIPT",
          "letterImage":{
              "binaryFileId":"e04e2f69-967d-4abe-8849-b8addec78cc2",
              "content":"",
              "fileName":"account_receivable.png",
              "fileSize":106376
          }
      }
  ]
}



@Injectable()
export class MockSettingService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getAll(): Observable<Setting> {
    return of(itemTwo);
  }


  update(setting: Setting): Observable<Setting> {

    return of(itemTwo);
  }

}
